<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <form #searchForm="ngForm" class="form-validate" (ngSubmit)="submit()">
      <ng-container *hasAnyAuthority="['admin', 'regis_zone'];except: ['hospital']">
        <div class="row mb-3">
          <label for="report-zone" class="col-form-label col-xl-2">เขต</label>
          <div class="col-xl-4">
            <app-select-zone id="report-zone" name="report-zone"
                             [(ngModel)]="params.zone"
                             (ngModelChange)="onSelectZone()"></app-select-zone>
          </div>
          <label [for]="'report-province'" class="col-form-label col-xl-2">จังหวัด</label>
          <div class="col-xl-4">
            <app-province-autocomplete [id]="'report-province'" [name]="'report-province'"
                                       [(ngModel)]="params.province"
                                       [restrictZone]="params.zone">
            </app-province-autocomplete>
          </div>
        </div>
        <div class="row mb-3">
          <label for="hospital" class="col-form-label col-xl-2">หน่วยบริการ</label>
          <div class="col-xl-4">
            <app-hospital-autocomplete id="hospital" name="hospital"
                                       [attr.autofocus]="false"
                                       [restrictZoneId]="params.zone?.id"
                                       [restrictProvinceId]="params.province?.id"
                                       [(ngModel)]="params.hospital"></app-hospital-autocomplete>
          </div>
        </div>
      </ng-container>
      <ng-container *hasAnyAuthority="['hospital']">
        <div class="row mb-3">
          <label for="hospital2" class="col-form-label col-xl-2">หน่วยบริการ</label>
          <div class="col-xl-4">
            <input class="form-control-plaintext" readonly name="hospital2" id="hospital2"
                   [ngModel]="params.hospital?.hcode + ': ' + params.hospital?.hname">
          </div>
        </div>
      </ng-container>
      <div class="row mb-3">
        <label for="budget-year" class="col-form-label col-xl-2 ui-require">ปีงบประมาณ</label>
        <div class="col-auto">
          <select id="budget-year" name="budget-year" class="form-select"
                  [(ngModel)]="params.budgetYear"
                  (ngModelChange)="onBudgetYearChange()"
                  required
                  #budgetYearInput="ngModel">
            @for (budgetYear of budgetYearMonth() | keyvalue; track budgetYear.key) {
              <option [ngValue]="+budgetYear.key">{{ budgetYear.key }}</option>
            }
          </select>
          @if (budgetYearInput.invalid && (budgetYearInput.dirty || budgetYearInput.touched)) {
            <custom-error *ngIf="budgetYearInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
        <label for="report-month" class="col-form-label col-auto">เดือน</label>
        <div class="col-auto">
          <select id="report-month" name="report-month" class="form-select"
                  [(ngModel)]="params.month"
                  required
                  #monthInput="ngModel">
            <option [value]="undefined">กรุณาเลือก</option>
            @for (item of budgetYearMonthList(); track item) {
              <option [ngValue]="item.month">{{ item.yearMonthName }}</option>
            }
          </select>
          @if (monthInput.invalid && (monthInput.dirty || monthInput.touched)) {
            <custom-error *ngIf="monthInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
        <label for="report-round" class="col-form-label col-auto">รอบที่</label>
        <div class="col-auto">
          <select id="report-round" name="report-round" class="form-select"
                  [(ngModel)]="params.round"
                  required
                  #roundInput="ngModel">
            <option [value]="'01'">01</option>
            <option [value]="'02'">02</option>
          </select>
          @if (roundInput.invalid && (roundInput.dirty || roundInput.touched)) {
            <custom-error *ngIf="roundInput.hasError('required')" error="*จำเป็น"></custom-error>
          }
        </div>
      </div>
      <div class="row">
        <div class="offset-xl-2">
          <button ngbAutofocus type="submit" class="btn btn-primary me-2">
            <i class="bi bi-search me-1"></i>ค้นหาข้อมูล
          </button>
          <button type="button" (click)="reset();" class="btn btn-default">ล้างค่า</button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card custom-box mb-3 border-0">
  <div class="card-body">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-pills" [destroyOnHide]="false">
      <li [ngbNavItem]="1">
        <button ngbNavLink>โมเดล 1, 2, 4</button>
        <ng-template ngbNavContent>
          <app-point-summary-report-table #searchReportProvince [params]="params"></app-point-summary-report-table>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <button ngbNavLink>โมเดล 5</button>
        <ng-template ngbNavContent>
          <app-point-summary-report-bkk-table #searchReportBkk [params]="params"></app-point-summary-report-bkk-table>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
</div>
